import { markRaw, shallowRef } from 'vue'
import type { PageState } from '@/types/ainotebook'
import { usePdfJs } from './usePdfJs'

export function usePdfDocument() {
  const pdfDoc = shallowRef<any>(null)

  async function loadFromFile(file: File): Promise<{ numPages: number }> {
    const pdf = await usePdfJs()
    const buf = await file.arrayBuffer()
    const task = pdf.getDocument({ data: buf })
    pdfDoc.value = markRaw(await task.promise)
    return { numPages: pdfDoc.value.numPages as number }
  }

  function initPages(numPages: number): PageState[] {
    return Array.from({ length: numPages }, (_, i) => ({
      pageNumber: i + 1,
      width: 0,
      height: 0,
      pageUrl: '',
      thumbUrl: '',
      renderRev: 0,
      analyzed: false,
      analyzing: false,
      blocks: [],
    }))
  }

  function cleanupPdf() {
    try { pdfDoc.value?.destroy?.() } catch {}
    pdfDoc.value = null
  }

  return { pdfDoc, loadFromFile, initPages, cleanupPdf }
}
